// components/ColumnVisibilityModal.jsx
import React from "react";
import { Modal, Form, Button } from "react-bootstrap";

const ColumnVisibilityModal = ({
  show,
  onClose,
  columns,           // array de columnas [{ key, text, ... }]
  columnVisibility,  // objeto { [key]: booleanOculto }
  onToggleColumn,    // función (key) => void
  title = "Configuración de Columnas",
  className = "modal-columnas",
}) => {
  return (
    <Modal show={show} onHide={onClose} className={className}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          {columns.map((column) => (
            <Form.Check
              key={column.key}
              type="switch"
              id={column.key}
              label={column.text}
              checked={!columnVisibility[column.key]} // si NO está oculta => switch ON
              onChange={() => onToggleColumn(column.key)}
              className="mb-2"
            />
          ))}
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ColumnVisibilityModal;
